import { IconButton } from "@mui/material";
import classNames from "classnames";

import { SettingsIcon } from "@/shared/foundation/icons/mui";
import { type PanelState } from "@/shared/state/visualization";

import type { PlotPanelSettingsSidebarProps } from "../../PanelSettings/PlotPanelSettings";
import { SidebarViewType, useWorkspaceSidebar } from "../../sidebarContext";
import { useEphemeralWorkspaceState } from "../../WorkspaceCtx";

interface OpenPanelSettingsProps {
  className?: classNames.Argument;
  state: PanelState;
  /**
   * A plot series to spotlight when the settings open: its row expands,
   * scrolls into view, and pulses. Only meaningful when `state` is a plot
   * panel.
   */
  seriesId?: string;
}

/**
 * A button that selects its panel and opens the panel settings sidebar.
 */
export function OpenPanelSettings({
  className,
  state,
  seriesId,
}: OpenPanelSettingsProps) {
  const workspace = useEphemeralWorkspaceState();
  const sidebar = useWorkspaceSidebar();

  const selectPanel = () => {
    workspace.selectPanel(state.id);
    if (seriesId !== undefined) {
      sidebar.openView<PlotPanelSettingsSidebarProps>({
        type: SidebarViewType.PanelSettings,
        data: {
          field: "Series",
          seriesId,
          spotlightKey: performance.now(),
        },
      });
      return;
    }
    sidebar.openView({
      type: SidebarViewType.PanelSettings,
      data: undefined,
    });
  };

  return (
    <IconButton
      aria-label="open-panel-settings"
      className={classNames(className)}
      onClick={selectPanel}
      size="small"
      title="Open panel settings"
    >
      <SettingsIcon fontSize="inherit" />
    </IconButton>
  );
}
